import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";
import { useIntl } from "react-intl";

const LinkToLogoInstructions: FC = ({ children }) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();
  return (
    <a
      href={intl.formatMessage(
        {
          id: "logoInstructionsUrl",
          defaultMessage:
            "{supportUrl}/hc/fi/articles/360000365985-Luotettava-Kumppani-logo",
        },
        {
          supportUrl: config?.supportUrl,
        }
      )}
      id="rpInstructionsLink"
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToLogoInstructions;
